import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchFriendRequests = () => {
    const [friendRequests, setFriendRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    const fetchFriendRequests = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_API_AUDIENCE,
            }
        });

        const response = await fetch(`${apiUrl}/api/friends/GetFriendRequests`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.ok) {
            const data = await response.json();
            setFriendRequests(data);
        } else {
            console.error('Failed to fetch friend requests');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchFriendRequests();
    }, [getAccessTokenSilently, apiUrl]);

    return {
        friendRequests,
        setFriendRequests,
        loading,
        refreshFriendRequests: fetchFriendRequests,
    };
};
